module.exports = __webpack_public_path__ + "img/slider_4.f13c8155.jpg";